import { styled } from 'styled-components';
import { Col, Row } from 'antd';

export const GridRow = styled(Row)``;
export const GridCol = styled(Col)``;
